const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Targeter+Content+API

function getTargetersContent(targeters, config) {
    if (targeters.length) {
        const url = '/api/personalization/targeter?includeTargeters=' + targeters.join(',');

        return ufeApi
            .makeRequest(
                url,
                {
                    method: 'GET'
                },
                config
            )
            .then(data => (data.errorCode ? Promise.reject(data) : data));
    } else {
        return Promise.resolve([]);
    }
}

module.exports = getTargetersContent;
